import classNames from 'classnames';

import { CanaryAIAttribution } from '@hcs/canaryai';
import { Skeleton } from '@hcs/design-system';
import { useScreenSize } from '@hcs/hooks';
import { CERBERUS_STATS_FIELDS } from '@hcs/types';

import { CERBERUS_STATS_FIELD_CONFIGS } from '../../configs';
import { CERBERUS_STATS_TYPE } from '../../constants';
import {
  CerberusStatsDetailsTable,
  CerberusStatsDetailsTableProps,
} from '../CerberusStatsDetailsTable';

import pdfStyles from '../MarketInsightsPdfStyles.module.css';
import styles from './CerberusStatsSummary.module.css';
const DisplayName =
  CERBERUS_STATS_FIELD_CONFIGS[CERBERUS_STATS_FIELDS.displayName].Display;

export interface CerberusStatsSummaryProps
  extends Pick<
    CerberusStatsDetailsTableProps,
    | 'forPdf'
    | 'blurred'
    | 'dataHcName'
    | 'className'
    | 'cerberusStats'
    | 'fields'
    | 'hideInteractive'
  > {
  hideTitle?: boolean;
  children?: React.ReactNode;
  cerberusStatsIsLoading?: boolean;
  summaryData?: string;
  summaryDataIsLoading?: boolean;
}
export const CerberusStatsSummary = ({
  dataHcName,
  className,
  cerberusStats,
  hideInteractive,
  hideTitle,
  children,
  cerberusStatsIsLoading,
  summaryData,
  summaryDataIsLoading,
  forPdf,
  fields,
  blurred,
}: CerberusStatsSummaryProps) => {
  const { isPhoneWidth } = useScreenSize();
  return (
    <div
      className={classNames(className, {
        [classNames(pdfStyles.PdfSummary, pdfStyles.FullWidthContainer)]:
          forPdf,
      })}
    >
      {!hideTitle && (
        <div className={styles.Name}>
          {cerberusStatsIsLoading ? (
            <Skeleton type="text" width={100} />
          ) : (
            <>
              <DisplayName cerberusStats={cerberusStats} />{' '}
              {cerberusStats?.type === CERBERUS_STATS_TYPE.Msa ? 'MSA' : ''}
            </>
          )}
        </div>
      )}
      <div
        data-testid="summary-text"
        className={classNames(styles.SummaryText, {
          [styles.SummaryTextMargin]: hideTitle,
        })}
      >
        {summaryDataIsLoading ? (
          <>
            <Skeleton type="text" repeat={6} marginTop={7} />
            <Skeleton type="text" repeat={1} marginTop={10} width={230} />
          </>
        ) : (
          <>
            {summaryData}
            {summaryData && <CanaryAIAttribution />}
          </>
        )}
      </div>
      {children}
      {cerberusStatsIsLoading ? (
        <Skeleton type="text" repeat={isPhoneWidth ? 11 : 6} marginTop={7} />
      ) : (
        <CerberusStatsDetailsTable
          hideInteractive={hideInteractive}
          forPdf={forPdf}
          dataHcName={dataHcName}
          cerberusStats={cerberusStats}
          fields={fields}
          blurred={blurred}
        />
      )}
    </div>
  );
};
